import { APPLICATION_ERROR } from '@americanexpress/one-app-ducks/lib/error';
import reportError from './reportError';

export const APPLICATION_ERROR_COLLECTION_METHOD = 'applicationError';

/**
 * Reports an application runtime error to the application server.
 * The application `error` state will be updated with the given error code.
 *
 * @param {number|string} errorCode The error code associated with the failed action.
 * @param {Error} error The error to report.
 * @param {*} [otherData] An object containing extra information to add to the report.
 * @returns {ReportErrorThunkAction}
 *  A Promise that resolves after the report has been submitted to the application server.
 */
export default function reportApplicationError(errorCode, error, otherData) {
  return (dispatch) => {
    const code = String(errorCode);
    const result = dispatch(reportError(error, {
      collectionMethod: APPLICATION_ERROR_COLLECTION_METHOD,
      ...otherData,
      code,
    }));
    dispatch({
      type: APPLICATION_ERROR,
      code,
    });
    return result;
  };
}

/** @typedef {import('./reportError').ReportErrorThunkAction} ReportErrorThunkAction */
